import {userConstants} from '../../_constants';

export function listDepartments(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_DEPARTMENTS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_DEPARTMENTS_SUCCESS:
      return {
        loading: false,
        // dataDepartments: action.data.data,
        ...action.data,
      };
    case userConstants.GET_LIST_DEPARTMENTS_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
